import { ConnectwareError, ConnectwareErrorType } from '..'

export class CommissioningFileParsingError extends ConnectwareError {
    static override is (e: unknown): e is CommissioningFileParsingError {
        return e instanceof CommissioningFileParsingError
    }

    constructor (
        /**
         * The list of errors obtained while parsing the commissioning file
         *
         * @example Map<"property path" | null, "error message">
         */
        readonly parseErrors: ReadonlyMap<string | null, string>
    ) {
        super(ConnectwareErrorType.BAD_REQUEST, 'Given commissioning file is invalid', { errors: Array.from(parseErrors) })
    }
}
